import React from 'react'
import Cakecomponent from '../components/cakes/Cakecomponent'

export default function Cakes() {
  return (


    <Cakecomponent />


    )
}
